import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ZoneButton from './ZoneButton';
import ZoneButtonsWrapper from './ZoneButtonsWrapper';
import {
  getRelativeHeight,
  getRelativeWidth,
} from '../../components/CardReader/CardReader';
import { MOBILE_BREAKPOINT_IN_PX } from '../../constants';

const ButtonAB = styled(ZoneButton)`
  margin-top: 10%;
  width: 36%;
  height: ${getRelativeHeight(57)};
`;

const ButtonABC = styled(ZoneButton)`
  width: 53%;
  height: ${getRelativeHeight(57)};
`;

const ButtonABCD = styled(ZoneButton)`
  height: ${getRelativeHeight(148)};
  width: 74%;
`;

const DownButtonWrapper = styled.div`
  display: flex;
  margin-top: 2%;
  justify-content: space-between;
  top: ${getRelativeHeight(-220)};
  left: ${getRelativeHeight(0)};
  height: ${getRelativeHeight(88)};
  width: ${getRelativeWidth(389)};

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    margin-top: 0;
  }
`;

const DownButton = styled(ZoneButton)`
  height: ${getRelativeHeight(148)};
  width: ${getRelativeWidth(64)};
  cursor: pointer;
`;

const ZoneButtonsB = ({
  onClickZoneAB,
  onClickZoneABC,
  onClickZoneABCD,
  onClickDownButton,
}) => (
  <ZoneButtonsWrapper>
    <ButtonAB onClick={onClickZoneAB} />
    <ButtonABC onClick={onClickZoneABC} />
    <DownButtonWrapper>
      <ButtonABCD onClick={onClickZoneABCD} />
      <DownButton onClick={onClickDownButton} />
    </DownButtonWrapper>
  </ZoneButtonsWrapper>
);

ZoneButtonsB.propTypes = {
  onClickZoneAB: PropTypes.func.isRequired,
  onClickZoneABC: PropTypes.func.isRequired,
  onClickZoneABCD: PropTypes.func.isRequired,
  onClickDownButton: PropTypes.func.isRequired,
};

export default ZoneButtonsB;
